import React, { useEffect, useState } from "react";
import { Home, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import AcontecimientosService from "../services/acontecimientosService.tsx";
import { useAuth0 } from "@auth0/auth0-react";
import TimelineEventos from "./TimelineEventos.tsx";
import { Evento } from "../types/Evento.tsx";
import Loading from "./Loading.tsx";

export default function MisEventos({ onBack }: { onBack: () => void }) {
  const { getAccessTokenSilently } = useAuth0();
  const [eventos, setEventos] = useState<Evento[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const storedSocio = localStorage.getItem("socioSeleccionado");
        if (!storedSocio) {
          throw new Error("No hay socio seleccionado");
        }
        const socio = JSON.parse(storedSocio);
        const id = socio.socio_id;
        if (!id) {
          throw new Error("No se pudo identificar el socio seleccionado");
        }

        const data = await AcontecimientosService.getAcontecimientosSocios(
          id,
          getAccessTokenSilently
        );
        setEventos(data);
      } catch (err: any) {
        console.error("Error al cargar los eventos:", err.message);
        setError(err?.message || "Error al cargar los eventos.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [getAccessTokenSilently]);

  return (
    <div className="container mx-auto px-4 py-6 sm:px-6 lg:px-8">
      {/* Migas de pan (Breadcrumb) */}
      <nav className="mb-6" aria-label="Breadcrumb">
        <ol className="flex flex-wrap items-center space-x-1 sm:space-x-2 md:space-x-3">
          <li className="flex items-center">
            <Link
              to="/inicio"
              className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-800"
            >
              <Home className="w-4 h-4 mr-2" />
              Inicio
            </Link>
          </li>
          <li className="flex items-center">
            <ChevronRight className="w-4 h-4 text-gray-400" />
            <span className="ml-1 sm:ml-2 text-sm font-medium text-gray-600">
              Mis Eventos
            </span>
          </li>
        </ol>
      </nav>

      {/* Título */}
      <h1 className="text-2xl sm:text-3xl font-bold mb-6 text-gray-800">
        Mis Eventos
      </h1>

      {/* Contenido */}
      {loading ? (
        <Loading />
      ) : error ? (
        <div className="rounded-xl border border-rose-200 bg-rose-50 px-4 py-3">
          <p className="text-sm font-semibold text-rose-800">{error}</p>
          {error.toLowerCase().includes('no hay socio') && (
            <div className="mt-2 flex flex-wrap items-center gap-2">
              <p className="text-xs text-rose-600">
                Seleccioná un socio para ver sus eventos.
              </p>
              <Link
                to="/seleccionar-socio"
                className="rounded-lg bg-rose-600 px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-rose-700"
              >
                Seleccionar socio
              </Link>
            </div>
          )}
        </div>
      ) : (
        <TimelineEventos eventos={eventos} />
      )}
    </div>
  );
}
